import React, { useEffect, useRef } from 'react';

//Az első renderen kívül mindig fusson le a func(), ha a "deps" változik

const useDidMountEffect = (func, deps) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) func();
        else didMount.current = true;
    }, deps);
}

export default useDidMountEffect;